var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col flex-grow w-full" },
    [
      _vm.description
        ? _c("MarkdownContent", {
            staticClass:
              "markdown-content--typography max-w-readable self-center",
            attrs: { content: _vm.description }
          })
        : _vm._e(),
      _c(
        "BaseTransition",
        {
          attrs: {
            duration: 100,
            animations: "resize-height",
            "enter-to-class": "max-h-41px",
            "leave-class": "max-h-41px"
          }
        },
        [
          _vm.$ui.mobile && _vm.searching
            ? _c(
                "div",
                [
                  _vm.$ui.mobile && _vm.searching
                    ? _c(
                        "BasePageHeader",
                        {
                          staticClass: "mt-4 flex",
                          attrs: { "no-margin": "" }
                        },
                        [
                          _c("span", { staticClass: "truncate" }, [
                            _vm._v(_vm._s(_vm.title))
                          ]),
                          _c("span", { staticClass: "pl-1" }, [
                            _vm._v(
                              "(" + _vm._s(_vm.filteredMovies.length) + ")"
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        {
          staticClass: "movies-browser__header relative flex items-center -mx-2"
        },
        [
          _c(
            "BaseTransition",
            {
              attrs: {
                "enter-duration": 150,
                "leave-duration": 75,
                animation: "fade",
                "enter-active-class": "delay-75"
              }
            },
            [
              !_vm.$ui.mobile || !_vm.searching
                ? _c(
                    "div",
                    {
                      staticClass: "flex items-center",
                      class: {
                        "ml-2": _vm.$viewer.isActive,
                        "overflow-hidden hover:overflow-visible": !_vm.actionsMenuOpen
                      }
                    },
                    [
                      !_vm.$viewer.isActive
                        ? _c("BaseMenu", {
                            attrs: {
                              options: [
                                {
                                  text: "Import to collection",
                                  icon: "upload",
                                  handle: _vm.importMedia
                                },
                                {
                                  text: "Export collection",
                                  icon: "download",
                                  handle: _vm.exportCollection
                                }
                              ]
                            },
                            on: {
                              opened: function($event) {
                                _vm.actionsMenuOpen = true
                              },
                              closed: function($event) {
                                _vm.actionsMenuOpen = false
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var toggleActionsMenu = ref.toggle
                                    return [
                                      _c("BaseButton", {
                                        staticClass:
                                          "w-8 h-8 -ml-1 hover:bg-black-overlay",
                                        staticStyle: {
                                          "padding-left": ".4375rem",
                                          "padding-right": ".4375rem"
                                        },
                                        attrs: {
                                          icon: "more",
                                          "aria-label": "Open actions menu"
                                        },
                                        on: { click: toggleActionsMenu }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1585090554
                            )
                          })
                        : _vm._e(),
                      _c("BasePageHeader", { staticClass: "flex" }, [
                        _c("span", { staticClass: "truncate" }, [
                          _vm._v(_vm._s(_vm.title))
                        ]),
                        _c("span", { staticClass: "pl-1" }, [
                          _vm._v("(" + _vm._s(_vm.filteredMovies.length) + ")")
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _c("div", { staticClass: "flex-grow" }),
          !_vm.$viewer.isActive
            ? _c("BaseMenu", {
                attrs: {
                  direction: _vm.searching ? "top-left" : "top-right",
                  options: _vm.watchedFilterOptions
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var toggleWatchedFilterMenu = ref.toggle
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "flex items-center h-8 ml-2",
                              on: { click: toggleWatchedFilterMenu }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "mr-1 text-sm hidden whitespace-no-wrap desktop:block"
                                },
                                [_vm._v(_vm._s(_vm.watchedFilterText))]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "mr-1 text-sm whitespace-no-wrap desktop:hidden"
                                },
                                [_vm._v(_vm._s(_vm.watchedFilterMobileText))]
                              ),
                              _c("BaseIcon", {
                                staticClass: "w-5 h-5",
                                attrs: { name: "cheveron-down" }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1460169976
                )
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "relative transition-all duration-150",
              class: {
                "w-full mx-2 desktop:w-64": _vm.searching,
                "w-8 flex-shrink-0": !_vm.searching
              }
            },
            [
              _c(
                "BaseTransition",
                { attrs: { duration: 100, animation: "fade" } },
                [
                  _c("BaseButton", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.searching,
                        expression: "!searching"
                      }
                    ],
                    ref: "filtersTrigger",
                    staticClass:
                      "\n                        absolute right-0 top-1/2 transform -translate-y-1/2 w-8 h-8 justify-center rounded-full\n                        hover:bg-black-overlay\n                    ",
                    staticStyle: { padding: "0" },
                    attrs: {
                      icon: "search",
                      "icon-class": "w-4 h-4",
                      "aria-label": "Filter collection",
                      title:
                        'Press "f" to filter ' +
                        _vm.collectionQualifier +
                        " collection"
                    },
                    on: { click: _vm.showFilters }
                  })
                ],
                1
              ),
              _c(
                "BaseTransition",
                { attrs: { duration: 150, animations: "fade resize-width" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.searching,
                        expression: "searching"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchFilter,
                        expression: "searchFilter"
                      }
                    ],
                    ref: "searchFilter",
                    staticClass:
                      "\n                        absolute w-full right-0 top-1/2 transform -translate-y-1/2\n                        text-sm py-1 bg-transparent appearance-none border-b-2 border-primary-200\n                        focus:border-primary-300\n                    ",
                    attrs: {
                      placeholder:
                        "Search in " +
                        _vm.collectionQualifier +
                        " collection...",
                      "aria-label": "Collection filter"
                    },
                    domProps: { value: _vm.searchFilter },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape"
                          ])
                        ) {
                          return null
                        }
                        return _vm.hideFilters($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchFilter = $event.target.value
                      }
                    }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.filteredMovies.length > 0
        ? _c("MoviesGrid", {
            key: "movies",
            attrs: { "within-collection": "", movies: _vm.filteredMovies }
          })
        : _c(
            "div",
            {
              staticClass:
                "flex flex-col flex-grow items-center justify-center h-24 top-0 inset-x-0"
            },
            [
              _c("BaseIcon", {
                staticClass: "w-16 h-16 text-gray-700 mb-4",
                attrs: { name: "search-empty" }
              }),
              _c("span", { staticClass: "text-lg" }, [
                _vm._v("No movies found matching these filters.")
              ])
            ],
            1
          ),
      _vm.showGoTop
        ? _c(
            "button",
            {
              staticClass:
                "\n            fixed flex items-center justify-center bottom-0 right-0 mr-4 mb-8 z-30\n            bg-primary-500 text-white rounded-full w-10 h-10 shadow-lg hover:bg-red-700\n        ",
              attrs: {
                type: "button",
                title: "Go top",
                "aria-label": "Go top"
              },
              on: { click: _vm.goToTop }
            },
            [
              _c("BaseIcon", {
                staticClass: "w-8 h-8",
                attrs: { name: "cheveron-up" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }